import { DeleteStoreButton } from '../../../../../../customized/fresh-watch/components/StoreManager/DeleteStore/DeleteStoreButton';
import { ToggleComponent } from '../../../../../../featureToggle';
import { DeleteGroupButton } from './DeleteGroupButton';

export default ToggleComponent(DeleteGroupButton, {
  styledComponentsVariants: {
    'fresh-watch': DeleteStoreButton,
  },
});
